//Lib
import axios from 'axios';

//Create Dynamic Hook for all basic petitions and create a constant with URL for each type of petition.
export const useAxios = () => {
  const post = async (url, data) => {
    try {
      const res = await axios.post(url, data);
      return res;
    } catch (err) {
      console.error(err);
    }
  };

  const put = async (url, data) => {
    try {
      if (data._id !== '') {
        const res = await axios.put(`${url}/${data._id}`, data);
        return res;
      }
    } catch (err) {
      console.error(err);
    }
  };

  const putWithoutID = async (url, data) => {
    try {
      const res = await axios.put(url, data);
      return res;
    } catch (err) {
      console.error(err);
    }
  };

  const getList = async url => {
    let data = [];
    try {
      data = await axios.get(url);
    } catch (err) {
      console.error(err);
    }

    return data;
  };

  const getListConditional = async (url, body) => {
    let data = [];
    try {
      data = await axios.get(url, { data: body });
    } catch (err) {
      console.error(err);
    }

    return data;
  };

  const getListConditionalPost = async (url, body) => {
    let data = [];
    try {
      data = await axios.post(url, body);
    } catch (err) {
      console.error(err);
    }

    return data;
  };

  const getElement = async (url, dataProcessed) => {
    let data = {};
    try {
      data = await axios.get(`http://localhost:4000/api/club/${dataProcessed.id}`);
    } catch (err) {
      console.error(err);
    }

    return data;
  };
  return {
    post,
    put,
    putWithoutID,
    getList,
    getElement,
    getListConditional,
    getListConditionalPost,
  };
};
